import { IReceiptOrderRcptAmt, IReceiptOrderRefundParams, IRefundOrderInfo, IRefundOrderParams } from '../../../types/air-splitting/bill-management/refundOrder';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 账单管理 - 退款订单列表
 */
export async function queryRefundOrderList(param: IRefundOrderParams) {
  let data = [] as IRefundOrderInfo[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IRefundOrderParams;

  try {
    const { code, context, message } = await Http.post<{ data: IRefundOrderInfo[]; total: number }>(`${hostUrl}/pay/refund-order/page-list`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IRefundOrderInfo[]; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 账单管理 - 退款订单导出
 */
export async function exportRefundOrder(params: IRefundOrderParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/refund-order/export`,
      params,
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 空中分账 - 账单管理 - 收款订单退款
 */
export async function receiptOrderRefund(params: IReceiptOrderRefundParams) {
  try {
    const { code, message } = await Http.post(`${hostUrl}/pay/receipt-order/refund`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 空中分账 - 账单管理 - 获取收款订单所有金额
 */
export async function queryReceiptOrderRcptAmt(id: number) {
  let data = {} as IReceiptOrderRcptAmt;

  try {
    const { code, context, message } = await Http.get<IReceiptOrderRcptAmt>(`${hostUrl}/pay/receipt-order/rcpt-amt`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IReceiptOrderRcptAmt;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}
